export default "__VITE_ASSET__DoHfgi1h__"